/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

export enum HierarchiesSequence {
  WORKSPACE = 'WORKSPACE',
  ORGANIZATION = 'ORGANIZATION',
  SITE = 'SITE',
  SYSTEM = 'SYSTEM',
  LOCATION = 'LOCATION',
  SUBLOCATION = 'SUBLOCATION',
  ASSET = 'ASSET',
  DEVICE = 'DEVICE',
}

export interface PaginationType {
  rowId: string;
  page: number;
  totalItems: number;
  totalPages: number;
}

export enum FileStatuses {
  done = 'done',
  loading = 'loading',
  error = 'error',
}

export type FileDataType = {
  file?: Blob;
  data?: any;
  errors?: Array<any>;
  name?: string;
  isFullHierarchy?: boolean;
};

export enum ResourceSatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export type ResourceDtoType = {
  uuid: string;
  resourceId?: number;
  ddId: string;
  name: string;
  description?: string;
  status: ResourceSatus;
  type: string;
  updatedBy?: string;
};

export interface SiteType extends ResourceDtoType {
  orgDDId: string;
  orgName: string;
  orgUUId: string;
}

export interface LocationType extends ResourceDtoType {
  devices?: string;
  locationTypeDDId: string;
  locationTypeName: string;
  locationTypeUUId: string;
  parentLocationTypeDDId?: string;
  parentLocationTypeName?: string;
  parentLocationDDId?: string;
  parentLocationName?: string;
  parentLocationUUId?: string;
  siteDDId: string;
  siteUUId?: string;
  siteName: string;
  systemDDId?: string;
  systemName?: string;
  systemUUId?: string;
}

export interface SystemType extends ResourceDtoType {
  siteDDId: string;
  siteUUId: string;
  siteName: string;
}

export interface OrganizationType extends ResourceDtoType {
  resourceId: number;
  siteDtos?: Array<SiteType>;
}

export enum DeviceIdentifier {
  DEVICEID = 'deviceId',
  ALIAS = 'alias',
  DIMENSIONS = 'dimensions',
}

export interface DeviceType extends ResourceDtoType {
  deviceTypeDDId: string;
  deviceTypeName: string;
  deviceTypeUUId: string;
  deviceIdentifier?: DeviceIdentifier;
  version?: string;
}

export type DeviceDtoType = {
  ddId: string;
  deviceTypeDDId: string;
  deviceTypeName: string;
  deviceTypeUUId: string;
  name: string;
  alias?: string;
  deviceIdentifier?: DeviceIdentifier;
  dimensions?: Record<string, unknown>;
  description?: string;
};

export interface AssetType extends ResourceDtoType {
  parentLocationName: string;
  parentLocationUUId: string;
  siteDDId: string;
  siteName: string;
  siteUUId: string;
}

export enum RelationshipsTableTabs {
  parentLocations = 'parentLocations',
  childLocations = 'childLocations',
  assignedAssets = 'assignedAssets',
  assignedDevices = 'assignedDevices',
}

export type DetailsURLMatchType = {
  workspaceId?: string;
  organizationId?: string;
  assetId?: string;
  siteId?: string;
  systemId?: string;
  locationId?: string;
  locationTypeId?: string;
  assetTypeId?: string;
  deviceTypeId?: string;
  deviceId?: string;
};
